var _circle, _rect, _rect2, _rect3, _rect4, _path, _rect5, _rect6, _rect7, _rect8, _path2, _rect9, _rect0, _rect1, _rect10, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCountLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#CFD7FD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 9.55566,
    width: 6,
    height: 5.55556,
    fill: "#FCCC97"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 9.55566,
    width: 6,
    height: 1.59259,
    fill: "#FFB655"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.48151,
    y: 13.5186,
    width: 2.33333,
    height: 0.333333,
    rx: 0.166667,
    fill: "#FFB655"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4.48151,
    y: 14.1111,
    width: 1.48148,
    height: 0.333333,
    rx: 0.166667,
    fill: "#FFB655"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.97113 12.5742C5.96496 11.605 5.95632 9.64455 5.97113 9.55566H8.06373V12.5742H5.97113Z",
    fill: "#F49227"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 9.55566,
    width: 6,
    height: 5.55556,
    fill: "#FFB655"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 9.55566,
    width: 6,
    height: 1.59259,
    fill: "#F49227"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 10.4815,
    y: 13.5186,
    width: 2.33333,
    height: 0.333333,
    rx: 0.166667,
    fill: "#FFB655"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 10.4815,
    y: 14.1111,
    width: 1.48148,
    height: 0.333333,
    rx: 0.166667,
    fill: "#FFB655"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9712 12.5742C11.965 11.605 11.9563 9.64455 11.9712 9.55566H14.0638V12.5742H11.9712Z",
    fill: "#E07912"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 4,
    width: 6,
    height: 5.55556,
    fill: "#FCCC97"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 4,
    width: 6,
    height: 1.59259,
    fill: "#FFB655"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 7.48148,
    y: 7.96289,
    width: 2.33333,
    height: 0.333333,
    rx: 0.166667,
    fill: "#FFB655"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 7.48148,
    y: 8.55542,
    width: 1.48148,
    height: 0.333333,
    rx: 0.166667,
    fill: "#FFB655"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97113 7.01852C8.96496 6.04938 8.95632 4.08889 8.97113 4H11.0637V7.01852H8.97113Z",
    fill: "#F49227"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountLogo);
export default __webpack_public_path__ + "static/media/countLogo.215f7f3e82efd054ccc5da9bb5c4c594.svg";
export { ForwardRef as ReactComponent };